  export const countryCodes = [
    { code: '93', name: 'Afghanistan' },
    { code: '355', name: 'Albania' },
    { code: '213', name: 'Algeria' },
    { code: '376', name: 'Andorra' },
    { code: '244', name: 'Angola' },
    { code: '54', name: 'Argentina' },
    { code: '374', name: 'Armenia' },
    { code: '61', name: 'Australia' },
    { code: '43', name: 'Austria' },
    { code: '994', name: 'Azerbaijan' },
    { code: '973', name: 'Bahrain' },
    { code: '880', name: 'Bangladesh' },
    { code: '375', name: 'Belarus' },
    { code: '32', name: 'Belgium' },
    { code: '55', name: 'Brazil' },
    { code: '359', name: 'Bulgaria' },
    { code: '855', name: 'Cambodia' },
    { code: '237', name: 'Cameroon' },
    { code: '1', name: 'Canada' },
    { code: '56', name: 'Chile' },
    { code: '86', name: 'China' },
    { code: '57', name: 'Colombia' },
    { code: '385', name: 'Croatia' },
    { code: '53', name: 'Cuba' },
    { code: '357', name: 'Cyprus' },
    { code: '420', name: 'Czech Republic' },
    { code: '45', name: 'Denmark' },
    { code: '593', name: 'Ecuador' },
    { code: '20', name: 'Egypt' },
    { code: '372', name: 'Estonia' },
    { code: '358', name: 'Finland' },
    { code: '33', name: 'France' },
    { code: '995', name: 'Georgia' },
    { code: '49', name: 'Germany' },
    { code: '233', name: 'Ghana' },
    { code: '30', name: 'Greece' },
    { code: '852', name: 'Hong Kong' },
    { code: '36', name: 'Hungary' },
    { code: '354', name: 'Iceland' },
    { code: '91', name: 'India' },
    { code: '62', name: 'Indonesia' },
    { code: '98', name: 'Iran' },
    { code: '964', name: 'Iraq' },
    { code: '353', name: 'Ireland' },
    { code: '972', name: 'Israel' },
    { code: '39', name: 'Italy' },
    { code: '81', name: 'Japan' },
    { code: '962', name: 'Jordan' },
    { code: '7', name: 'Kazakhstan' },
    { code: '254', name: 'Kenya' },
    { code: '965', name: 'Kuwait' },
    { code: '371', name: 'Latvia' },
    { code: '961', name: 'Lebanon' },
    { code: '370', name: 'Lithuania' },
    { code: '352', name: 'Luxembourg' },
    { code: '853', name: 'Macao' },
    { code: '60', name: 'Malaysia' },
    { code: '356', name: 'Malta' },
    { code: '52', name: 'Mexico' },
    { code: '373', name: 'Moldova' },
    { code: '377', name: 'Monaco' },
    { code: '976', name: 'Mongolia' },
    { code: '212', name: 'Morocco' },
    { code: '95', name: 'Myanmar' },
    { code: '977', name: 'Nepal' },
    { code: '31', name: 'Netherlands' },
    { code: '64', name: 'New Zealand' },
    { code: '234', name: 'Nigeria' },
    { code: '47', name: 'Norway' },
    { code: '968', name: 'Oman' },
    { code: '92', name: 'Pakistan' },
    { code: '507', name: 'Panama' },
    { code: '51', name: 'Peru' },
    { code: '63', name: 'Philippines' },
    { code: '48', name: 'Poland' },
    { code: '351', name: 'Portugal' },
    { code: '974', name: 'Qatar' },
    { code: '40', name: 'Romania' },
    { code: '7', name: 'Russia' },
    { code: '966', name: 'Saudi Arabia' },
    { code: '65', name: 'Singapore' },
    { code: '421', name: 'Slovakia' },
    { code: '386', name: 'Slovenia' },
    { code: '27', name: 'South Africa' },
    { code: '82', name: 'South Korea' },
    { code: '34', name: 'Spain' },
    { code: '94', name: 'Sri Lanka' },
    { code: '46', name: 'Sweden' },
    { code: '41', name: 'Switzerland' },
    { code: '886', name: 'Taiwan' },
    { code: '66', name: 'Thailand' },
    { code: '90', name: 'Turkey' },
    { code: '380', name: 'Ukraine' },
    { code: '971', name: 'United Arab Emirates' },
    { code: '44', name: 'United Kingdom' },
    { code: '1', name: 'United States' },
    { code: '598', name: 'Uruguay' },
    { code: '84', name: 'Vietnam' },
    { code: '967', name: 'Yemen' },
    { code: '263', name: 'Zimbabwe' }
  ];